document.addEventListener("DOMContentLoaded", function () {
  const listCollection = document.querySelector(".list-collections");
  const images = listCollection.querySelectorAll("img");
  const list_a = listCollection.querySelectorAll("a");

  const jsonStr = [
    {
      title: "About Ampace",
      text: "As a joint venture between ATL and CATL, Ampace focuses on advanced lithium-ion battery business, covering the R&D, production, sales and services in three major fields, namely Energy Storage Systems, Micro Electric Vehicles and Power Batteries.",
    },
    {
      title: "Safety Commitment for Full Life Cycle",
      text: "Leveraging years of experience in lithium-ion battery safety technology, we ensure unwavering commitment to safety throughout the full life cycle.",
    },
    {
      title: "Exceptional Technical Performance",
      text: "Longevity, Unparalleled Reliability, and Extensive Temperature Range",
    },
    {
      title: "Exceptional Technical Performance",
      text: "It is equipped with advanced instruments and methodologies that support the testing validation, and characterization of raw materials, components, battery cell, battery module, and battery pack as well as application systems. The lab has been certified with CNAS/ISO17025 and IATF16949 standards.",
    },
    {
      title: "Product quality control",
      text: "We ensure comprehensive monitoring and strict control throughout the entire production process, from materials to finished products. Leveraging advanced technologies like machine vision and knowledge mapping, we achieve real-time monitoring of manufacturing quality and implement automatic testing for complete traceability of manufacturing information.",
    },
    {
      title: "Green Development",
      text: "Through relentless efforts, we actively contribute to a green, low-carbon, and sustainable energy system by minimizing the environmental impacts of our business activities at Ampace.",
    },
  ];

  /*images.forEach((image) => {
    image.addEventListener("click", function () {
      // 移除所有a标签的.a_click样式
      images.forEach((a) => {
        a.classList.remove("a_click");
      });

      // 为当前点击的a标签添加.a_click样式
      this.classList.add("a_click");
    });
  });*/
  images.forEach((image, index) => {
    var nextElement = this.nextElementSibling;
    const textOverlay = document.createElement("span");
    const h3 = document.createElement("h3");
    h3.textContent = jsonStr[index].title;
    textOverlay.textContent = jsonStr[index].text;
    textOverlay.appendChild(h3);
    image.parentNode.appendChild(textOverlay);
    // 设置标题和文本内容的布局样式
    textOverlay.style.display = "flex";
    textOverlay.style.flexDirection = "column-reverse";
    //h3.style.marginBottom = "60px";
  });
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  list_a.forEach((a) => {
    if (isMobile) {
      a.removeAttribute("href");
      a.addEventListener("click", function () {
        a.removeAttribute("href");
        list_a.forEach((a2) => {
          a2.classList.remove("a_click");
        });
        a.classList.add("a_click");
      });
    } else {
      a.addEventListener("mouseover", function (event) {
        a.classList.add("a_click");
      });
      a.addEventListener("mouseout", function (event) {
        a.classList.remove("a_click");
      });
    }
  });
  const list_span = listCollection.querySelectorAll("span");
  list_span.forEach((span) => {
    if (isMobile) {
      span.addEventListener("click", function (event) {
        list_span.forEach((s) => {
          s.classList.remove("span_click");
        });
        span.classList.add("span_click");
      });
    } else {
      span.addEventListener("mouseover", function (event) {
        span.classList.add("span_click");
      });
      span.addEventListener("mouseout", function (event) {
        span.classList.remove("span_click");
      });
    }
  });

  // 点击页面空白处时，去除 a_click 类
  document.addEventListener("click", function (event) {
    const target = event.target;
    // 判断点击的目标是否是 a 元素或其子元素
    if (!target.closest(".list-collections")) {
      // 如果不是，则去除 a_click 类
      list_a.forEach((a) => {
        a.classList.remove("a_click");
      });
      list_span.forEach((span) => {
        span.classList.remove("span_click");
      });
    }
  });
});
